import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { EmailInput, UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { TemplatesList } from "../../templates/TemplatesList";
import { EmailOverlay } from "../overlay/EmailOverlay";
import { Rokojori } from "../Rokojori";
import { RokojoriUser } from "./RokojoriUser";


export class SignUpOverlay
{
  static readonly attribute = new ElementAttribute( "sign-up" );

  static applyOnDocument()
  {
    SignUpOverlay.attribute.forEachInDoc( e => SignUpOverlay.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {  

    let functionName:MultiString =
    {
      en:"sign-up",
      de:"anmelden"
    }; 

    PageHandler.setFunctionHandleLink( e, Rokojori.locale( functionName ),
      ()=> 
      { 
        let template = TemplatesList.SIGN_UP_OVERLAY;
        
        let onSend = async ( email:string, password:string )=>
        {
          let signupOK = await Rokojori.$.userSystem.signup( email, password );
          //if ( response.)
          //this.requestAccount( email );

          return Promise.resolve( signupOK )
        }

        EmailOverlay.open( template, onSend ); 
      } 
    );
  }

  /*
  static async requestAccount( email:string, language:LanguageCode = LanguageCodes.en ):Promise<void>
  {    
    let signUpRequest = new UserSignUpRequest();
    let input = new EmailInput();
    input.email = email;
    input.language = Rokojori.$.pageHandler.currentLanguage as any;

    let response = await signUpRequest.request( Rokojori.phpContext, input );

    console.log( response );
    

    return Promise.resolve();
  }
  */

}